/**
 * Centralised strings configuration for the Topshop app.
 * All user-facing text should be defined here for easier maintenance
 * and future internationalisation (i18n) readiness.
 */

export const STRINGS = {
  nav: {
    menu: "Menu",
    loginSignUp: "LOGIN / SIGN UP",
    signOut: "SIGN OUT",
    wishlist: "Wishlist",
    shopTopshop: "Shop Topshop",
    shopTopman: "Shop Topman",
    unableToLoadNavigation: "Unable to load navigation items",
    ariaLabels: {
      goToWishlist: "Go to your wishlist",
      goToAccount: "Go to your account",
      searchMenu: "Search Menu",
      closeMenu: "Close menu",
      navigationMenuDescription:
        "Navigation menu for categories and my account",
    },
  },

  footer: {
    headings: {
      brand: "THE BRAND",
      social: "FOLLOW US",
      help: "HELP",
      policies: "POLICIES",
    },
    links: {
      about: "ABOUT",
      press: "PRESS",
      instagram: "INSTAGRAM",
      tiktok: "TIKTOK",
      pinterest: "PINTEREST",
      deliveryAndReturns: "DELIVERY & RETURNS",
      customerCare: "CUSTOMER CARE",
      dataProtection: "DATA PROTECTION",
      compliance: "COMPLIANCE",
      cybersecurity: "CYBERSECURITY",
      corporateResponsibility: "CORPORATE RESPONSIBILITY",
      privacyAndCookies: "Privacy & Cookies",
      termsAndConditions: "Terms & Conditions",
      termsAndConditionsShort: "Ts&Cs",
      accessibility: "Accessibility",
    },
    ariaLabels: {
      footerNavigation: "Footer navigation",
      instagramNewTab: "Follow us on Instagram (opens in a new tab)",
      tiktokNewTab: "Follow us on TikTok (opens in a new tab)",
      pinterestNewTab: "Follow us on Pinterest (opens in a new tab)",
      corporateResponsibilityNewTab:
        "Corporate Responsibility (opens in a new tab)",
      privacyPolicyNewTab: "Privacy Policy (opens in a new tab)",
      termsAndConditionsNewTab: "Terms & Conditions (opens in a new tab)",
      accessibilityNewTab: "Accessibility (opens in a new tab)",
      shopTopshopAsos: "Shop Topshop on ASOS (opens in a new tab)",
      shopTopmanAsos: "Shop Topman on ASOS (opens in a new tab)",
    },
    copyright: "TOPSHOP",
    copyrightMobile: "Topshop",
    toast: {
      title: "You're browsing from outside of UK",
      messagePrefix:
        "We currently only ship to the UK. Head to asos.com to shop",
      and: "and",
      topshop: "TOPSHOP",
      topman: "TOPMAN",
      dismissLabel: "Dismiss UK shipping notification",
    },
  },

  addToBag: {
    addToBag: "ADD TO BAG",
    outOfStock: "OUT OF STOCK",
    addedToBag: "ADDED TO BAG",
    addingToBag: "Adding to bag",
    discountExclusion: {
      message: "This item is excluded from discount codes.",
    },

    errors: {
      selectOptions:
        "Please select from the available colour and size options.",
      failedToAdd: "Failed to add to bag.",
      quantityLimit: "You've reached the maximum purchase limit for this item.",
    },
  },

  gallery: {
    ariaLabels: {
      closeGallery: "Close gallery",
      previousImage: "Previous image",
      nextImage: "Next image",
      productImageAlt: "Product image",
      videoDescription: "Video showing model wearing",
    },
  },

  sizeSelection: {
    selectSize: "SELECT SIZE",
    ariaLabels: {
      selectSizeDescription: "Select a size to add it to your bag.",
      close: "Close",
    },
  },

  wishlist: {
    previousPrice: "Previous Price",
    currentPrice: "Current Price",
    selectSize: "SELECT SIZE",
    addToBag: "Add to bag",
    addingToBag: "Adding to bag",
  },

  productListing: {
    readMore: "READ MORE",
    readLess: "READ LESS",
    latestDrops: "Latest Drops",
  },

  filters: {
    apply: "Apply",
    ariaLabels: {
      applyFiltersDescription: "Apply filters to your results",
    },
  },

  bag: {
    item: "ITEM",
    items: "ITEMS",
    inBag: "IN BAG",
    total: "TOTAL",
    goToCheckout: "GO TO CHECKOUT",
    ariaLabels: {
      bagIsUpdating: "bag is updating",
      itemInYourBag: "item in your bag",
      itemsInYourBag: "items in your bag",
      viewYourBag: "View your bag.",
    },
  },

  video: {
    skipVideo: "Skip Video",
    ariaLabels: {
      skipVideo: "Skip video",
    },
  },

  sizeGuide: {
    title: "Size Guide",
    errorLoading: "Error loading size guide",
    ariaLabels: {
      dimensionSwitch: "Dimension Switch",
      closeSizeGuide: "Close Size Guide",
      isLoading: "Size Guide is Loading",
      viewSizeGuideInformation: "View size guide information",
    },
  },

  errors: {
    codes: {
      "404": {
        title: "Something's gone wrong",
        message: "Sorry, there was a problem loading this page.",
      },
      "500": {
        title: "Something's gone wrong",
        message: "Sorry – we're having technical trouble",
      },
      default: {
        title: "Something's gone wrong",
        message: "Sorry – this page isn't available.",
      },
    },
    maintenance: {
      title: "maintenance",
      message:
        "Sorry, you can't access the page because we are updating the website. Please check back here again later.",
      refresh: "REFRESH",
    },
    brandName: "Topshop",
  },

  noResults: {
    title: "No results for",
    message:
      "Try again with different words or find inspiration from our recommendations below.",
    seeMore: "See More",
    trending: "TRENDING",
    ariaLabels: {
      previousProduct: "Previous product",
      nextProduct: "Next product",
    },
  },

  videoOverlay: {
    description: "Topshop Topman choose your journey",
  },
} as const;

export type Strings = typeof STRINGS;
